import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';

const getQueryParams = (params) => {
    let { first, rows, sortField, sortOrder, search, ...retVal } = params.params;

    const searchText = search || retVal.filters?.searchText || retVal.Filters?.SearchText || "";

    retVal.Pagination = {
        PageNumber: (first / rows) + 1,
        PageSize: rows
    };
    retVal.filters = { searchText: searchText };
    retVal.sortString = '';

    if (sortField) {
        retVal.sortField = sortField;
        retVal.sortDesc = sortOrder < 0;
    }
    return {
        url: params.url,
        params: { requestData: JSON.stringify(retVal) }
    };
};

const applicationsAPI = createApi({
    baseQuery: defautBaseQuery,
    reducerPath: 'applicationsAPI',
    endpoints: (builder) => ({
        getApplications: builder.query({
            query: getQueryParams,
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getApplicationProductsByAppId: builder.query({
            query: getQueryParams,
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getLinkedApplicationsByChemProduct: builder.query({
            query: getQueryParams,
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        })
    })
});

export const {
    useLazyGetApplicationsQuery,
    useLazyGetApplicationProductsByAppIdQuery,
    useLazyGetLinkedApplicationsByChemProductQuery
} = applicationsAPI;

export default applicationsAPI;
